export default function nestedService() {
  return function generate(viewField, engineApi) {
    const element = engineApi.register.setCommonAttributes('div', viewField, engineApi);
    element.addAttribute('ec-nested', '');
    viewField.model && element.addAttribute('fb-register', viewField.model);
    element.setHtml(
      `<ec-flex-rows>${engineApi
        .handleProperties(viewField, engineApi)
        .map(el => {
          return el.toString();
        })
        .join('')}</ec-flex-rows>`
    );

    return element;
  };
}
